export interface BeProps {
  align:
    | 'baseline'
    | 'top'
    | 'middle'
    | 'bottom'
    | 'text-bottom'
    | 'text-top'
    | 'items-start'
    | 'items-end'
    | 'items-center'
    | 'items-baseline'
    | 'items-stretch'
    | 'content-start'
    | 'content-end'
    | 'content-center'
    | 'content-between'
    | 'content-around'
    | 'content-stretch'
    | 'self-auto'
    | 'self-start'
    | 'self-end'
    | 'self-center'
    | 'self-baseline'
    | 'self-stretch'
  bg:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'danger'
    | 'light'
    | 'dark'
    | 'white'
    | 'transparent'
  border:
    | 'top'
    | 'right'
    | 'bottom'
    | 'left'
    | '0'
    | 'top-0'
    | 'right-0'
    | 'bottom-0'
    | 'left-0'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'danger'
    | 'light'
    | 'dark'
    | 'white'
  d:
    | 'none'
    | 'inline'
    | 'inline-block'
    | 'block'
    | 'table'
    | 'table-row'
    | 'table-cell'
    | 'flex'
    | 'inline-flex'
  display: '1' | '2' | '3' | '4'
  embed:
    | 'responsive'
    | 'responsive .embed-responsive-item'
    | 'responsive iframe'
    | 'responsive embed'
    | 'responsive object'
    | 'responsive video'
  fixed: 'top' | 'bottom'
  flex:
    | 'row'
    | 'column'
    | 'row-reverse'
    | 'column-reverse'
    | 'wrap'
    | 'nowrap'
    | 'wrap-reverse'
    | 'fill'
    | 'grow-0'
    | 'grow-1'
    | 'shrink-0'
    | 'shrink-1'
  float: 'left' | 'right' | 'none'
  font:
    | 'weight-light'
    | 'weight-lighter'
    | 'weight-normal'
    | 'weight-bold'
    | 'weight-bolder'
    | 'italic'
  h: '25' | '50' | '75' | '100' | 'auto'
  justify:
    | 'content-start'
    | 'content-end'
    | 'content-center'
    | 'content-between'
    | 'content-around'
  min: 'vw-100' | 'vh-100'
  overflow: 'auto' | 'hidden'
  position: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky'
  rounded:
    | 'sm'
    | 'top'
    | 'right'
    | 'bottom'
    | 'left'
    | 'lg'
    | 'circle'
    | 'pill'
    | '0'
  shadow: 'sm' | 'lg' | 'none'
  text:
    | 'monospace'
    | 'justify'
    | 'wrap'
    | 'nowrap'
    | 'truncate'
    | 'left'
    | 'right'
    | 'center'
    | 'lowercase'
    | 'uppercase'
    | 'capitalize'
    | 'white'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'danger'
    | 'light'
    | 'dark'
    | 'body'
    | 'muted'
    | 'black-50'
    | 'white-50'
    | 'hide'
    | 'decoration-none'
    | 'break'
    | 'reset'
  w: '25' | '50' | '75' | '100' | 'auto'
  img: 'fluid' | 'thumbnail'
  col:
    | 'auto'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | 'form-label'
    | 'form-label-lg'
    | 'form-label-sm'
  mr:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  ml:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  mt:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  mb:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  mx:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  my:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  m:
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | 'n1'
    | 'n2'
    | 'n3'
    | 'n4'
    | 'n5'
    | 'auto'
  pr: '0' | '1' | '2' | '3' | '4' | '5'
  pl: '0' | '1' | '2' | '3' | '4' | '5'
  pt: '0' | '1' | '2' | '3' | '4' | '5'
  pb: '0' | '1' | '2' | '3' | '4' | '5'
  px: '0' | '1' | '2' | '3' | '4' | '5'
  py: '0' | '1' | '2' | '3' | '4' | '5'
  p: '0' | '1' | '2' | '3' | '4' | '5'
}
export const ruleSet = new Set([
  'align',
  'bg',
  'border',
  'd',
  'display',
  'embed',
  'fixed',
  'flex',
  'float',
  'font',
  'h',
  'justify',
  'min',
  'overflow',
  'position',
  'rounded',
  'shadow',
  'text',
  'w',
  'img',
  'col',
  'mr',
  'ml',
  'mt',
  'mb',
  'mx',
  'my',
  'm',
  'pr',
  'pl',
  'pt',
  'pb',
  'px',
  'py',
  'p'
])
